import React, { useEffect, useState } from "react";
import MenuLayout from "./MenuLayout";
import "../styles/AffiliatePage.css";
import { getReferral } from "../api/referrals";

const AffiliatePage = () => {
  const [referral, setReferral] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getReferral();
        setReferral(data);
      } catch (err) {
        setError(err.message || "خطا در دریافت اطلاعات همکاری");
      }
    };
    load();
  }, []);

  const withdrawable = referral?.withdrawable_amount ?? "—";

  return (
    <MenuLayout>
      <section className="aff-page">
        <header className="aff-header">
          <h1 className="aff-title">همکاری در فروش</h1>
          <p className="aff-subtitle">
            درآمد اضافه بساز ؛ با کمک به شناخته تر شدن تاچ پراپ ، درآمدت رو چند برابر کن
          </p>
        </header>

        {error && <div className="aff-error">{error}</div>}

        <div className="aff-referral-bar">
          <div className="aff-referral-link">
            <span className="aff-link-icon">🔗</span>
            <span className="aff-link-text">{referral?.referral_code ? `کد ریفرال: ${referral.referral_code}` : "کد ریفرال موجود نیست"}</span>
          </div>
          <div className="aff-referral-code">
            <span className="aff-code-label">موجودی:</span>
            <span className="aff-code-value">{withdrawable}</span>
          </div>
        </div>

        <div className="aff-stats">
          <div className="aff-stat-card">
            <div className="aff-stat-icon">
              <img src="/images/icons/affiliate-user.svg" alt="مشتری جذب شده" />
            </div>
            <div className="aff-stat-info">
              <div className="aff-stat-label">مشتری جذب شده :</div>
              <div className="aff-stat-value">{referral?.referral_count ?? "—"}</div>
            </div>
          </div>
          <div className="aff-stat-card">
            <div className="aff-stat-icon">
              <img src="/images/icons/affiliate-wallet.svg" alt="مبلغ هدیه" />
            </div>
            <div className="aff-stat-info">
              <div className="aff-stat-label">مبلغ هدیه :</div>
              <div className="aff-stat-value">{referral?.referral_bonus ?? "—"}</div>
            </div>
          </div>
          <div className="aff-stat-card">
            <div className="aff-stat-icon">
              <img src="/images/icons/affiliate-percent.svg" alt="درصد همکاری" />
            </div>
            <div className="aff-stat-info">
              <div className="aff-stat-label">درصد همکاری :</div>
              <div className="aff-stat-value">{referral?.commission_percentage ?? "—"}%</div>
            </div>
          </div>
        </div>

        <div className="aff-withdraw-note">
          برای برداشت سودت از همکاری با تاچ پراپ برو به قسمت برداشت سود و از قسمت حساب ها ، حساب رفرال رو انتخاب کن
        </div>
      </section>
    </MenuLayout>
  );
};

export default AffiliatePage;
